<template>
  <div class="home">
    <div class="concent">
      <div class="c_lbt" v-if="carouselList && carouselList.length > 0">
        <div class="carousel">
          <swiper
            class="mySwiper swiper-no-swiping"
            ref="mySwiper"
            :options="swiperOptions"
          >
            <swiper-slide v-for="(item, index) in carouselList" :key="index">
              <div class="swiper_side">
                <a
                  :href="
                    item.type == 3
                      ? item.external_link
                      : '/play-page?id=' +
                        item.id +
                        '&classify=' +
                        item.classify
                  "
                  target="_blank"
                  ><img class="index1" :src="item.img_url[0]" height="464"
                /></a>
              </div>
            </swiper-slide>
          </swiper>
          <div class="carousel-right">
            <ul class="cr-ul">
              <li
                :class="{
                  selectLi: slideIndex == index,
                  preselectLi: slideIndex - 1 == index,
                }"
                class="cu-li"
                v-for="(item, index) in carouselList"
                :key="index"
                @click="slideClick(index)"
              >
                <div class="cul_title1">
                  <p>{{ item.article_title }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="c_channel" v-if="channelList && channelList.length > 0">
        <div class="channel_item" v-for="item in channelList" :key="item.at_id">
          <a
            :href="
              item.at_name == '推荐'
                ? '/marvel-list?id=' + item.at_id
                : '/list-page?id=' + item.at_id
            "
            target="_blank"
          >
            {{ item.at_name }}
          </a>
        </div>
      </div>
      <div class="c_recommend" v-if="newList.length > 0">
        <div class="pub_title">
          <img :src="require('@/assets/home/tuijian.png')" alt="" />
          <h4>最新推荐</h4>
        </div>
        <div class="recommend_item">
          <swiper class="new_swiper" :options="newSwiperOptions">
            <swiper-slide v-for="item in newList" :key="item.id">
              <div class="item_list">
                <a
                  :href="
                    '/play-page?id=' + item.id + '&classify=' + item.classify
                  "
                  target="_blank"
                >
                  <div class="ril_img">
                    <img :src="item.img_url[0]" alt="" />
                    <div class="time">{{ item.video_duration }}</div>
                  </div>
                  <div class="ril_concent">
                    <div class="rilc_t1">{{ item.title }}</div>
                    <div class="rilc_t2" v-html="item.desc"></div>
                  </div>
                </a>
              </div>
            </swiper-slide>
          </swiper>
          <div
            v-if="hasMore"
            class="swiper-button-next new-button-next el-icon-arrow-right"
            slot="pagination"
          ></div>
          <div
            v-if="hasMore"
            class="swiper-button-prev new-button-prev el-icon-arrow-left"
            slot="pagination"
          ></div>
        </div>
      </div>
      <div class="c_billboard" v-if="hotList.length > 0">
        <div class="pub_title">
          <img :src="require('@/assets/home/reban.png')" alt="" />
          <h4>最热榜单</h4>
        </div>
        <div class="cb_concent">
          <div class="cbc_order">
            <div
              class="order_item"
              v-for="(item, index) in hotList"
              :key="item.id"
            >
              <a
                :href="
                  '/play-page?id=' + item.id + '&classify=' + item.classify
                "
                target="_blank"
              >
                <div class="orde_sum">0{{ index + 1 }}.</div>
                <div class="orde_title">
                  <div class="ot1">{{ item.title }}</div>
                  <div class="ot2" v-html="item.desc"></div>
                </div>
              </a>
            </div>
          </div>
          <div class="cbc_list">
            <div class="cl_item" v-for="item in hotList" :key="item.id">
              <a
                :href="
                  '/play-page?id=' + item.id + '&classify=' + item.classify
                "
                target="_blank"
              >
                <div class="cli_img">
                  <img :src="item.img_url[0]" alt="" />
                </div>
                <div class="cli_title">
                  <div class="cli_t1">{{ item.title }}</div>
                  <div class="cli_t2" v-html="item.desc"></div>
                </div>
              </a>
              <!--              <div-->
              <!--                class="cli_bg"-->
              <!--                :class="selectedId == item.id ? 'active' : ''"-->
              <!--              ></div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="c_like" v-if="followFirst || followSubList.length > 0">
        <div class="pub_title">
          <img :src="require('@/assets/home/like.png')" alt="" />
          <h4>你可能喜欢</h4>
        </div>
        <div class="ck_big" v-if="followFirst">
          <a
            :href="
              '/play-page?id=' +
              followFirst.id +
              '&classify=' +
              followFirst.classify
            "
            target="_blank"
          >
            <div class="ckb_img">
              <img :src="followFirstImg" alt="" />
              <div class="time">{{ followFirst.video_duration }}</div>
              <!--            <div class="time">02:25</div>-->
            </div>
            <div class="ckb_title">
              <div class="ckt1">{{ followFirst.title }}</div>
              <div class="ckt2" v-html="followFirst.desc"></div>
            </div>
          </a>
        </div>
        <div class="ck_small">
          <div class="ckm_item" v-for="item in followSubList" :key="item.id">
            <a
              :href="'/play-page?id=' + item.id + '&classify=' + item.classify"
              target="_blank"
            >
              <div class="cmi_img">
                <img :src="item.img_url[0]" alt="" />
                <div class="time">{{ item.video_duration }}</div>
                <!--              <div class="time">02:25</div>-->
              </div>
              <div class="cki_title">
                <div class="ckit1">{{ item.title }}</div>
                <div class="ckit2" v-html="item.desc"></div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="c_video" v-if="marvellousList.length > 0">
        <div class="pub_title">
          <img :src="require('@/assets/home/video.png')" alt="" />
          <h4>精彩视频</h4>
          <el-button type="text" class="cv_btn">
            <router-link
              :to="{
                path: '/marvel-list',
              }"
              target="_blank"
              >更多
            </router-link>
            <i class="el-icon-arrow-right el-icon--right"></i
          ></el-button>
        </div>
        <div class="cv_list">
          <swiper class="marvel_swiper" :options="swiperOptionsVideo">
            <swiper-slide v-for="item in marvellousList" :key="item.id">
              <div class="cvl_item">
                <a
                  :href="
                    '/play-page?id=' + item.id + '&classify=' + item.classify
                  "
                  target="_blank"
                >
                  <div class="cvl_img">
                    <img :src="item.img_url[0]" alt="" />
                    <div class="time">{{ item.video_duration }}</div>
                  </div>
                  <div class="cvl_title">{{ item.title }}</div>
                </a>
              </div>
            </swiper-slide>
          </swiper>
          <div
            class="swiper-button-next marvel-button-next el-icon-arrow-right"
            slot="pagination"
          ></div>
          <div
            class="swiper-button-prev marvel-button-prev el-icon-arrow-left"
            slot="pagination"
          ></div>
        </div>
      </div>
      <div class="c_video_channel" v-if="videoChannel.length > 0">
        <div
          class="cvc_item"
          v-for="item in videoChannel"
          :key="item.title"
          @click="isCollapse = item.id"
        >
          <router-link
            :to="{
              path: '',
            }"
            :class="isCollapse == item.id ? 'active' : ''"
            >{{ item.title }}
          </router-link>
        </div>
      </div>
      <video-normal v-if="isCollapse % 4 == 3" :id="isCollapse"></video-normal>
      <video-boutique v-if="isCollapse % 4 == 0"></video-boutique>
      <video-album v-if="isCollapse % 4 == 1" :id="isCollapse"></video-album>
      <video-master v-if="isCollapse % 4 == 2"></video-master>
    </div>
  </div>
</template>
<script>
let vm = null;
import videoNormal from "./component/video-normal.vue";
import videoBoutique from "./component/video-boutique.vue";
import videoAlbum from "./component/video-album.vue";
import videoMaster from "./component/video-master.vue";
import { getHomePage, getChannelList } from "@/api";

export default {
  components: { videoNormal, videoBoutique, videoAlbum, videoMaster },
  data() {
    return {
      hasMore: false,
      isHover: false,
      carouselList: [],
      newList: [],
      channelList: [],
      hotList: [],
      marvellousList: [],
      followFirst: {},
      followFirstImg: "",
      followSubList: [],
      slideIndex: 0,
      videoList: [
        {
          src: "http://7xqg8c.com1.z0.glb.clouddn.com/20210721103656/2167768_android_0_wh_781_456.jpeg",
        },
        {
          src: "http://7xqg8c.com1.z0.glb.clouddn.com/20210721103656/2167768_android_0_wh_781_456.jpeg",
        },
        {
          src: "http://7xqg8c.com1.z0.glb.clouddn.com/20210721103656/2167768_android_0_wh_781_456.jpeg",
        },
        {
          src: "http://7xqg8c.com1.z0.glb.clouddn.com/20210721103656/2167768_android_0_wh_781_456.jpeg",
        },
        {
          src: "http://7xqg8c.com1.z0.glb.clouddn.com/20210721103656/2167768_android_0_wh_781_456.jpeg",
        },
        {
          src: "http://7xqg8c.com1.z0.glb.clouddn.com/20210721103656/2167768_android_0_wh_781_456.jpeg",
        },
        {
          src: "http://7xqg8c.com1.z0.glb.clouddn.com/20210721103656/2167768_android_0_wh_781_456.jpeg",
        },
      ],
      swiperOptionsVideo: {
        navigation: {
          nextEl: ".marvel-button-next",
          prevEl: ".marvel-button-prev",
        },
        slidesPerView: 4.6,
      },
      newSwiperOptions: {
        navigation: {
          nextEl: ".new-button-next",
          prevEl: ".new-button-prev",
        },
        slidesPerView: 4.83,
      },
      videoChannel: [
        {
          id: 0,
          title: "精品IP",
        },
        {
          id: 1,
          title: "国内专辑",
        },
        {
          id: 5,
          title: "国外专辑",
        },
        {
          id: 2,
          title: "科技前沿大师谈",
        },
        {
          id: 3,
          title: "应急避险",
        },
        {
          id: 7,
          title: "国外视频",
        },
        {
          id: 11,
          title: "更多精彩",
        },
      ],
      isCollapse: 0,
    };
  },
  computed: {
    swiperOptions() {
      const status =
        this.carouselList && this.carouselList.length > 1 ? true : false;
      return {
        pagination: {
          el: ".swiper-pagination",
        },
        autoplay: status,
        loop: true, //循环
        preventClicksPropagation: true,
        on: {
          slideChangeTransitionEnd: () => {
            if (!this.$refs?.mySwiper?.$swiper) {
              return;
            }
            let swiper = this.$refs.mySwiper.$swiper;
            let activeIndex = swiper.activeIndex - 1;
            if (swiper.activeIndex == this.carouselList.length + 1) {
              return (this.slideIndex = 0);
            }
            this.slideIndex = activeIndex;
          },
          click: function () {
            const realIndex = this.realIndex;
            vm.handleGoods(realIndex);
          },
        },
      };
    },
  },
  created() {
    this.initHomePage();
    this.initChannelList();
    this.siteGray();
  },
  beforeDestroy() {
    document.body.classList.remove("site-gray");
  },
  methods: {
    // lbt 切换
    slideClick(index) {
      this.slideIndex = index;
      this.$refs.mySwiper.$swiper.slideTo(this.slideIndex + 1, 1000, false);
    },
    async initHomePage() {
      try {
        let { data } = await getHomePage({ type: 2 });
        this.carouselList = data.carousel_list;
        this.newList = data.new_list;
        this.hotList = data.hot_list.slice(0, 4);
        this.marvellousList = data.marvellous_list;
        this.followFirst = data.follow_list[0];
        this.followFirstImg = data.follow_list[0]
          ? data.follow_list[0].img_url[0]
          : "";
        this.followSubList = data.follow_list.slice(1, 5);
        if (data.new_list && data.new_list.length > 5) {
          this.hasMore = true;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async initChannelList() {
      try {
        let { data } = await getChannelList();
        this.channelList = data;
      } catch (e) {
        console.log(e);
      }
    },
    // 首页置灰
    siteGray() {
      this.$axios.get(`/mvideo/getTheme`).then((res) => {
        if (Number(res?.data?.vshi_val) === 1) {
          document.body.classList.add("site-gray");
        } else {
          document.body.classList.remove("site-gray");
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// title
.pub_title {
  position: relative;
  padding: 30px 0 16px;
  font-size: 30px;
  font-weight: 600;
  line-height: 42px;
  color: #353535;
  @include clearfix;

  //img {
  //  float: left;
  //  width: 36px;
  //  height: 36px;
  //  margin: 4px 4px 0 0;
  //}

  h4 {
    float: left;
    margin: 0;
  }
}
.home {
  background-image: url("~@/assets/back.png");
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  //overflow: hidden;
}

.concent {
  width: 1200px;
  //width: 62.5%;
  margin: 0 auto;

  .c_lbt {
    height: 464px;

    .carousel {
      width: 100%;
      height: 300px;
      margin: 0 0 0 0;

      img {
        vertical-align: middle;
      }

      .mySwiper {
        z-index: 3;

        .swiper_side {
          width: 100%;
          height: 464px;
          overflow: hidden;
          text-align: center;

          .index1 {
            position: relative;
            z-index: 2;
          }

          .index2 {
            position: relative;
            top: -464px;
            z-index: 1;
            width: 100%;
            overflow: hidden;
            -webkit-filter: blur(15px);
            -moz-filter: blur(15px);
            -o-filter: blur(15px);
            -ms-filter: blur(15px);
            filter: blur(15px);
          }
        }
      }

      .carousel-right {
        @include wrap;

        position: relative;
        height: 464px;
        margin-top: -464px;

        .cr-ul {
          position: absolute;
          top: 0;
          right: 0;
          z-index: 999;
          box-sizing: border-box;
          width: 300px;
          height: 464px;
          padding: 44px 0;
          margin: 0;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            #344285 49%,
            rgba(0, 0, 0, 0) 100%
          );

          .cu-li {
            position: relative;
            box-sizing: border-box;
            height: 76px;
            //padding: 14px 24px;
            //overflow: hidden;
            //text-overflow: ellipsis;
            //white-space: nowrap;
            list-style: none;
            cursor: pointer;
          }

          .cu-li::before {
            position: absolute;
            bottom: 0;
            left: 15px;
            width: 266px;
            height: 1px;
            content: "";
            background-color: #686565;
          }

          .cul_title1 {
            display: flex;
            align-items: center;
            height: 50px;
            padding: 13px 24px;
            text-align: justify;

            p {
              padding: 0;
              margin: 0;
              line-height: 25px;
              @include fontSize(18px, 500, #fff);
              @include textoverflow(2);
            }
          }

          //.cul_title2 {
          //  line-height: 22px;
          //  @include fontSize(16px, 400, #fff);
          //}

          .selectLi {
            background: rgba(172, 220, 255, 0.41);
            border-radius: 0 30px 0 0;
          }

          .selectLi::before {
            display: none;
          }
          .preselectLi::before {
            display: none;
          }
        }
      }
    }
  }

  .c_channel {
    display: flex;
    flex-wrap: wrap;
    padding: 24px 0 0;

    .channel_item {
      position: relative;
      width: 220px;
      margin-bottom: 10px;
      font-size: 22px;
      font-weight: 600;
      line-height: 30px;
      color: #353535;
      a {
        font-family: PingFangSC-Semibold, sans-serif;
        color: #353535;
        text-decoration: none;
      }
      a:hover {
        color: #1f91f4;
      }
    }

    .channel_item:nth-child(1)::before,
    .channel_item:nth-child(2)::before,
    .channel_item:nth-child(3)::before,
    .channel_item:nth-child(4)::before,
    .channel_item:nth-child(5)::before {
      //position: absolute;
      //top: 14px;
      //right: 67px;
      //width: 1px;
      //height: 42px;
      //content: "";
      //background: #979797;
      //filter: blur(1px);
      //border: 1px solid #979797;
      @include channelSize;
    }

    .channel_item:nth-child(6n + 6) {
      width: 100px;
    }
  }

  .c_recommend {
    height: 290px;
    .pub_title {
      img {
        float: left;
        width: 36px;
        margin: 3px 5px 0 0;
      }
    }

    .recommend_item {
      position: relative;

      //padding-bottom: 20px;
      height: 210px;
      .item_list {
        //float: left;
        width: 208px;
        //margin-right: 40px;
        background: #fff;
        box-shadow: 2px 2px 18px 0 rgba(173, 159, 159, 0.5);
        a {
          text-decoration: none;
        }
        .ril_img {
          position: relative;
          width: 100%;
          height: 118px;
          background-color: #999;

          img {
            width: 100%;
            height: 100%;
          }

          .time {
            position: absolute;
            right: 0;
            bottom: 0;
            padding: 5px 10px;
            font-size: 16px;
            font-weight: 400;
            line-height: 22px;
            color: #fff;
          }
        }

        .ril_concent {
          height: 50px;
          padding: 7px 12px 15px;
          background-color: #fff;

          .rilc_t1 {
            font-size: 18px;
            font-weight: 400;
            line-height: 25px;
            color: #000;
            @include textoverflow;
          }

          .rilc_t2 {
            font-size: 16px;
            font-weight: 400;
            line-height: 22px;
            color: #666;
            @include textoverflow;
            ::v-deep * {
              padding: 0;
              margin: 0;
              @include textoverflow;
            }
          }
        }
      }
      .swiper-container {
        position: relative;
        height: 100%;
      }
      .swiper-slide {
        //margin-right: 40px;
        width: 240px;
      }

      .swiper-button-prev {
        top: 41px !important;
        left: 0 !important;
        width: 28px;
        height: 37px;
        margin-top: 0;
        background: #f4f4f4;
        border-radius: 0 100px 100px 0;
      }

      .swiper-button-next {
        top: 41px !important;
        right: 0 !important;
        width: 28px;
        height: 37px;
        margin-top: 0;
        background: #f4f4f4;
        border-radius: 100px 0 0 100px;
      }

      .swiper-button-prev::after {
        content: " ";
        //margin-left: -6px;
        //font-size: 18px;
        //font-weight: 600;
        //color: #979797;
      }

      .el-icon-arrow-left::before {
        margin-left: -6px;
        font-size: 24px;
        font-weight: 600;
        color: #979797;
      }

      .swiper-button-next::after {
        content: " ";
        //margin-left: 6px;
        //font-size: 18px;
        //font-weight: 600;
        //color: #979797;
      }
      .el-icon-arrow-right::before {
        margin-left: 6px;
        font-size: 24px;
        font-weight: 600;
        color: #979797;
      }
    }
  }

  .c_billboard {
    .pub_title {
      img {
        float: left;
        width: 33px;
        margin: 5px 5px 0 0;
      }
    }
    .cb_concent {
      @include clearfix;

      .cbc_order {
        float: left;
        height: 280px;

        .order_item {
          width: 228px;
          height: 60px;
          padding: 5px 20px 5px 12px;
          @include clearfix;
          a {
            text-decoration: none;
          }
          .orde_sum {
            float: left;
            font-size: 18px;
            font-weight: 600;
            line-height: 25px;
            color: #7d7d7d;
          }

          .orde_title {
            float: left;
            width: 190px;
            margin-left: 10px;

            .ot1 {
              font-family: PingFangSC-Medium, sans-serif;
              font-size: 18px;
              font-weight: 500;
              line-height: 25px;
              color: #000;
              @include textoverflow;
            }

            .ot2 {
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              color: #666;
              @include textoverflow;
              ::v-deep * {
                padding: 0;
                margin: 0;
                @include textoverflow;
              }
            }
          }
        }

        .order_item:nth-child(1) {
          background: #d8d8d8 linear-gradient(180deg, #fff 0%, #ffeded 100%);
        }

        .order_item:nth-child(2) {
          background: #d8d8d8 linear-gradient(180deg, #fff 0%, #fdffdc 100%);
        }

        .order_item:nth-child(3) {
          background: #d8d8d8 linear-gradient(180deg, #fff 0%, #dcf0ff 100%);
        }

        .order_item:nth-child(1) .orde_sum {
          color: #ebce0a;
        }

        .order_item:nth-child(2) .orde_sum {
          color: #80c5e7;
        }

        .order_item:nth-child(3) .orde_sum {
          color: #ed9f2e;
        }

        .order_item:hover {
          background: #6890e3 linear-gradient(180deg, #c3c8fe 0%, #86b2fe 100%);
        }

        .order_item:hover .orde_sum,
        .order_item:hover .orde_title .ot1,
        .order_item:hover .orde_title .ot2 {
          color: #fff;
        }
      }

      .cbc_list {
        display: flex;
        float: left;

        .cl_item {
          position: relative;
          width: 207px;
          height: 275px;
          margin-left: 28px;
          overflow: hidden;
          a {
            text-decoration: none;
          }
          .cli_img {
            width: 100%;
            height: 195px;
          }
          .cli_img img {
            object-fit: cover;
            width: 100%;
            height: 100%;
          }

          .cli_title {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 183px;
            height: 48px;
            padding: 17px 12px;

            .cli_t1 {
              font-size: 18px;
              font-weight: 500;
              line-height: 25px;
              color: #fff;
              @include textoverflow;
            }

            .cli_t2 {
              font-size: 16px;
              font-weight: 400;
              line-height: 22px;
              color: #fff;
              @include textoverflow;
              ::v-deep * {
                padding: 0;
                margin: 0;
                @include textoverflow;
              }
            }
          }

          .cli_bg {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 3;
            width: 207px;
            height: 275px;
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0) 50%,
              #6d97ef 100%
            );
          }

          .active {
            background: none;
          }

          .cli_bg:hover {
            background: none;
          }
        }

        .cl_item:nth-child(1) {
          .cli_title {
            background-color: #f26d6d;
          }
        }

        .cl_item:nth-child(2) {
          .cli_title {
            background-color: #ed9f2e;
          }
        }

        .cl_item:nth-child(3) {
          .cli_title {
            background-color: #80c5e7;
          }
        }

        .cl_item:nth-child(4) {
          .cli_title {
            background-color: #6d97ef;
          }
        }
      }
    }
  }

  .c_like {
    @include clearfix;

    .pub_title {
      img {
        float: left;
        width: 36px;
        height: 36px;
        margin: 3px 5px 0 0;
      }
    }
    .ck_big {
      float: left;
      a {
        text-decoration: none;
      }
      .ckb_img {
        position: relative;
        width: 550px;
        height: 386px;
        overflow: hidden;

        img {
          object-fit: cover;
          width: 100%;
          height: 100%;
        }

        .time {
          width: 530px;
          //position: relative;
          //right: 10px;
          //bottom: 20px;
          //padding: 0 10px 15px 0;
          height: 28px;
          padding-right: 10px;
          margin-top: -36px;
          text-align: right;
          @include fontSize(16px, 400, #fff, 22px);
        }
      }

      .ckb_title {
        width: 550px;
        padding: 7px 0;

        .ckt1 {
          @include fontSize(20px, 400, #000, 28px);
        }

        .ckt2 {
          @include fontSize(16px, 400, #666, 22px);
          @include textoverflow;
          ::v-deep * {
            padding: 0;
            margin: 0;
            @include textoverflow;
          }
        }
      }
    }

    .ck_small {
      display: flex;
      flex-wrap: wrap;
      float: left;
      width: 650px;

      .ckm_item {
        width: 280px;
        margin-left: 45px;
        a {
          text-decoration: none;
        }

        .cmi_img {
          position: relative;
          width: 280px;
          height: 160px;
          overflow: hidden;

          img {
            object-fit: cover;
            width: 100%;
            height: 100%;
          }

          .time {
            width: 260px;
            //position: relative;
            height: 28px;
            margin-top: -36px;
            text-align: right;
            //padding: 0 5px 10px 0;
            @include fontSize(16px, 400, #fff, 22px);
          }
        }

        .cki_title {
          padding: 8px 0 0;

          .ckit1 {
            @include fontSize(18px, 400, #000, 25px);
            @include textoverflow;
          }

          .ckit2 {
            @include fontSize(16px, 400, #666, 22px);
            @include textoverflow;
            ::v-deep * {
              padding: 0;
              margin: 0;
              @include textoverflow;
            }
          }
        }
      }

      .ckm_item:nth-child(1),
      .ckm_item:nth-child(2) {
        margin-bottom: 10px;
      }
    }
  }

  .c_video {
    .pub_title {
      img {
        float: left;
        width: 36px;
        //height: 36px;
        margin: 13px 5px 0 0;
      }
    }
    .cv_btn {
      position: absolute;
      top: 30px;
      right: 0;
      @include fontSize(18px, 400, #383838);
      .el-icon--right {
        margin-left: -5px;
      }
      a {
        color: #383838;
        text-decoration: none;
      }
    }

    .cv_list {
      position: relative;

      .cvl_item {
        width: 220px;
        margin-right: 35px;
        a {
          text-decoration: none;
        }
        .cvl_img {
          position: relative;
          width: 100%;
          height: 125px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }

          .time {
            position: absolute;
            right: 0;
            bottom: 0;
            padding: 0 10px 10px 0;
            @include fontSize(16px, 400, #fff, 22px);
          }
        }

        .cvl_title {
          //height: 25px;
          margin-top: 10px;
          @include fontSize(18px, 400, #353535, 25px);
          @include textoverflow;
        }
      }

      .swiper-container {
        position: relative;
        height: 100%;
      }

      .swiper-button-prev {
        top: 44px !important;
        left: 0 !important;
        width: 28px;
        height: 37px;
        margin-top: 0;
        background: #f4f4f4;
        border-radius: 0 100px 100px 0;
      }

      .swiper-button-next {
        top: 44px !important;
        right: 0 !important;
        width: 28px;
        height: 37px;
        margin-top: 0;
        background: #f4f4f4;
        border-radius: 100px 0 0 100px;
      }

      .swiper-button-prev::after {
        content: " ";
        //margin-left: -6px;
        //font-size: 18px;
        //font-weight: 600;
        //color: #979797;
      }

      .el-icon-arrow-left::before {
        margin-left: -6px;
        font-size: 24px;
        font-weight: 600;
        color: #979797;
      }

      .swiper-button-next::after {
        content: " ";
        //margin-left: 6px;
        //font-size: 18px;
        //font-weight: 600;
        //color: #979797;
      }
      .el-icon-arrow-right::before {
        margin-left: 6px;
        font-size: 24px;
        font-weight: 600;
        color: #979797;
      }
    }
  }

  .c_video_channel {
    display: flex;
    margin: 40px 0 20px;

    .cvc_item {
      padding-right: 45px;

      a {
        text-decoration: none;
        @include fontSize(18px, 600, #353535, 25px);
      }

      .active {
        color: #769df0;
        border-bottom: 2px solid #769df0;
        //text-decoration-line: underline;
      }
    }
  }
}
</style>
